<template>
  <div>
    <span v-if="isEdditing" v-on-clickaway="cancel">
      <form class="form-inline" @submit.prevent="save">
        <div class="input-group">
          <input type="number" step="any" min="0" class="form-control" v-model="newPrice" style="width: 80px;">
          <span class="input-group-btn">
            <button type="submit" class="btn btn-success btn-noborder">
              <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
              <i class="fa fa-check" v-else></i>
            </button>
          </span>
        </div>
      </form>
    </span>

    <span @click="edit" v-else>
      <span class="editable text-primary" v-if="currentPrice">€ {{currentPrice}}</span>
      <span class="editable text-danger" v-else><i>n.n.b.</i></span>
    </span>

    <text-alert :alert.sync="alert"></text-alert>
  </div>
</template>

<script>
import http from '../utils/http'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],
  props: ['price', 'productId'],
  data () {
    return {
      currentPrice: this.price,
      newPrice: this.price,
      isEdditing: false,
      isLoading: false,
      alert: false
    }
  },
  created () {
    this.$root.$on('product-price-updated', this.onUpdate)
  },
  destroy () {
    this.$root.$off('product-price-updated', this.onUpdate)
  },
  methods: {
    edit () {
      this.isEdditing = true
      this.newPrice = this.currentPrice
    },
    cancel () {
      this.isEdditing = false
    },
    save () {
      this.isLoading = true

      const data = {
        price: this.newPrice
      }

      return http.patch(`/products/${this.productId}`, data)
        .then((response) => {
          this.currentPrice = this.newPrice
          this.isEdditing = false
          this.isLoading = false

          this.alert = { variant: 'success', message: 'Opgeslagen' }

          this.$root.$emit('product-price-updated', {
            product_id: this.productId,
            price: this.newPrice
          })
        })
        .catch(() => {
          this.isLoading = false
          this.alert = { variant: 'danger', message: 'Er is iets fout gegaan' }
        })
    },
    onUpdate (e) {
      if (this.productId === e.product_id) {
        this.currentPrice = e.price
        this.newPrice = e.price
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PriceEditable.vue?73201ca4